import React, { useState, useEffect, useCallback } from "react";
import { NavLink, useParams, useSearchParams } from "react-router-dom";
import { globalFileIcon } from "../../../../axiosInstance";
import { setPreload } from "../../../server/CartsOpen";
import CreateProductPopUp from "../products/CreateProductPopUp";
import {
  AddProductToCategory,
  getItemsPerCategoryPgw,
  checkProductExistence,
  createProduct
} from "../../../server/Product";
import { getFilters } from "../../../server/Filter";
import { useDispatch, useSelector } from "react-redux";

const ProductsEdit = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { id, slug } = useParams();

  const { stationId, categories } = useSelector((state) => ({
    stationId: state.user.stationId,
    filterList: state.displayProduct.filterList,
    categories: state.category.categories || [],
    params: state.parameters,
  }));
  const findCategoryRecursive = (list, targetId) => {
    for (const cat of list) {
      if (String(cat.id || cat.Id) === String(targetId)) {
        return cat;
      }
      if (cat.children && cat.children.length > 0) {
        const found = findCategoryRecursive(cat.children, targetId);
        if (found) return found;
      }
    }
    return null;
  };
  const currentCategory = findCategoryRecursive(categories, id);
  const [product, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [newMkt, setNewMkt] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const refreshProducts = useCallback(() => {
    if (!slug || !stationId) return;
    dispatch(setPreload(true));
    getItemsPerCategoryPgw(slug, stationId)
      .then((res) => setProducts(res.data.products || []))
      .catch(err => console.error(err))
      .finally(() => dispatch(setPreload(false)));
  }, [slug, stationId, dispatch]);

  useEffect(() => {
    dispatch(getFilters());
    refreshProducts();
  }, [refreshProducts, dispatch]);

  const [foundProduct, setFoundProduct] = useState(null);
  const handleCheckAndAdd = async () => {
    if (!newMkt) return;
    dispatch(setPreload(true));
    setErrorMessage("");
    setFoundProduct(null); 

    try {
      const checkRes = await checkProductExistence(newMkt, stationId);
      const productData = checkRes.data && checkRes.data.length > 0 ? checkRes.data[0] : null;
      if (productData) {
        const isAlreadyInSlug = productData.categories?.some(cat => cat.slug === slug);
        if (isAlreadyInSlug) {
          setErrorMessage("המוצר כבר קיים בקטגוריה הנוכחית");
        } else {
          setFoundProduct(productData);
          setErrorMessage(`האם תרצה להוסיף את המוצר "${productData.product.name}" לקטגוריה זו?`);
        }
      } else {
        setErrorMessage("המוצר לא נמצא במערכת. האם תרצה ליצור אותו?");
      }
    } catch (err) {
      setErrorMessage("אירעה שגיאה בבדיקה. נסה שוב.");
    } finally {
      dispatch(setPreload(false));
    }
  };

  const confirmAddProduct = async () => {
    if (!foundProduct) return;
    dispatch(setPreload(true));
    try {
      await dispatch(AddProductToCategory(slug, foundProduct.product.productId, stationId));
      setIsDialogOpen(false);
      setNewMkt("");
      setFoundProduct(null);
      refreshProducts();
    } catch (err) {
      setErrorMessage("אירעה שגיאה בהוספת המוצר.");
    } finally {
      dispatch(setPreload(false));
    }
  };
  return (
    <div className="products-edit">
      <h1 className="title-role">ניהול מוצרים</h1>

      <div className="items-container">
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <button className="add-product" onClick={() => { setIsDialogOpen(true); setErrorMessage(""); setNewMkt(""); }}>
            <img src={globalFileIcon + "plus.svg"} alt="plus" />
            <span>הוסף מוצר</span>
          </button>

          <div className="search">
            <input onChange={({ target }) => setSearch(target.value)} value={search} type="text" placeholder="חיפוש מוצר..." />
            <img src={globalFileIcon + (search ? "close.svg" : "search.svg")} alt="search" onClick={() => setSearch("")} />
          </div>
        </div>
      </div>

      <div className="product-edit-table">
        <table>
          <thead>
            <tr>
              <th>פרטים</th>
              <th>תמונה</th>
              <th>שם המוצר</th>
              <th>מותג</th>
              <th>ברקוד</th>
              <th>סטטוס</th>
            </tr>
          </thead>
          <tbody>
            {product.filter(x => x.name?.includes(search)).map((el) => (
              <tr key={el.gtin}>
                <td className="enter-img">
                  <NavLink to={`/edit-product/${el.productId}/information`} className="details-link">
                    <img src={globalFileIcon + "edit.svg"} alt="edit" />
                    <span>לפרטים</span>
                  </NavLink>
                </td>
                <td className="category-img">
                  <div className="img-load">
                    <img src={globalFileIcon + "picture.svg"} alt="prod" />
                  </div>
                </td>
                <td>{el.name}</td>
                <td>{el.brandName || "-"}</td>
                <td>{el.gtin}</td>
                <td className="status">
                  <select className="status-select" value={el.status} onChange={() => { }}>
                    <option value="VALID">פעיל</option>
                    <option value="INVALID">לא פעיל</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {isDialogOpen && (
        <div className="category-dialog-overlay">
          <div className="category-dialog-box">
            <span className="close-icon" onClick={() => setIsDialogOpen(false)}>×</span>
            <h2>הוספת מוצר לקטגוריה</h2>
            <input
              type="number"
              value={newMkt}
              onChange={(e) => {
                setNewMkt(e.target.value);
                if (errorMessage) setErrorMessage("");
              }}
              placeholder="הכנס מקט מוצר"
              autoFocus
            />
            {errorMessage ? (
              <div className="alert-box">
                <p style={{ color: foundProduct ? 'green' : 'red', margin: '10px 0', fontWeight: 'bold' }}>
                  {errorMessage}
                </p>

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  {foundProduct ? (
                    <button className="submit-button" onClick={confirmAddProduct}>
הוסף לקטגוריה                    </button>
                  ) : (
                    !errorMessage.includes("כבר קיים") && (
                      <button
                        className="create-new-product-btn"
                        onClick={() => {
                          setIsCreateModalOpen(true);
                          setTimeout(() => setIsDialogOpen(false), 0);
                        }}
                      >
                        יצירת מוצר חדש
                      </button>
                    )
                  )}

                  <button
                    className="cancel-button"
                    onClick={() => { setErrorMessage(""); setFoundProduct(null); }}
                    style={{ padding: '8px 15px', cursor: 'pointer' }}
                  >
                    ביטול
                  </button>
                </div>
              </div>
            ) : (
              <button className="submit-button" onClick={handleCheckAndAdd}>
                בדוק והוסף
              </button>
            )}
          </div>
        </div>
      )}
      <CreateProductPopUp
        isOpen={isCreateModalOpen}
        onClose={() => {
          setIsCreateModalOpen(false);
          refreshProducts();
        }}
        initialCategoryId={id}
        initialBarcode={newMkt}
        categoryName={currentCategory.name}
      />
    </div>
  );
};

export default ProductsEdit;
